import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlowDefinitionContext } from '../models/flow.model';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { Utils } from '../shared/utils';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FlowDefinitionContextService extends BaseService {
    controllerRoute = 'FlowDefinitionContext';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async getById(id: string): Promise<IBaseModel<FlowDefinitionContext>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<FlowDefinitionContext>>(`${this.apiBaseUrl}/${this.controllerRoute}/${id}`));
    }

    public async update(data: FlowDefinitionContext): Promise<IBaseModel<void>> {
        return await firstValueFrom(this.httpClient.put<IBaseModel<void>>(`${this.apiBaseUrl}/${this.controllerRoute}`, Utils.decycleFlowDefinitionContext(data)));
    }
}
